import { render, staticRenderFns } from "./SorryNotArea.vue?vue&type=template&id=49257173&"
import script from "./SorryNotArea.vue?vue&type=script&lang=ts&"
export * from "./SorryNotArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports